import React from 'react';
import { Tabs } from 'antd';
import { ROLES, ROLE_GROUPS } from '_helpers/roles';
import { SendNotifications } from './SendNotifications';
import { NotificationFeed } from './NotificationFeed';

export { NotificationsPage };

const { TabPane } = Tabs;

// Students: just their feed (section tabs).
// Teachers: a flat feed (now they get one too — job-completion notices, manager messages).
// Managers/headmasters: their feed + a compose tab.
function NotificationsPage() {
    const userData = JSON.parse(localStorage.getItem('userData')) || {};
    const isStudent = userData.role === ROLES.STUDENT;
    const canSend = ROLE_GROUPS.MANAGERS.includes(userData.role);

    return (
        <div className="att2-page soft-in">
            <div className="att2-head">
                <div className="att2-head-l">
                    <h1 className="att2-title">Thông báo</h1>
                </div>
            </div>
            {isStudent ? <NotificationFeed /> : !canSend ? <NotificationFeed flat /> : (
                <Tabs defaultActiveKey="feed">
                    <TabPane tab="Thông báo của tôi" key="feed">
                        <NotificationFeed flat />
                    </TabPane>
                    <TabPane tab="Gửi thông báo" key="send">
                        <SendNotifications />
                    </TabPane>
                </Tabs>
            )}
        </div>
    );
}
